import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import SweetAlert from 'sweetalert-react';
import { Redirect } from 'react-router-dom';
import { storageKeys, userKeys } from 'settings';
import {
  APIHandler,
  DataHandler,
  Email,
  Register,
  StorageHandler,
  Forgot,
} from 'C4';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const checkInputValidityFields = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = Array.from(selects);

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  // console.log('inputs', inputs);

  const emptyFields = [];
  inputs.forEach(function(input) {
    if (input.checkValidity() === false) {
      let name = input.name.replace(/reg_/g, '').replace(/_/g, ' ');
      console.log(name)
        if (name === 'custom 1') {
          name = 'salutation';
        }
        if (name === 'passwordConfirm') {
          name = 'confirm password';
        }
        emptyFields.push(name);
    }
  });

  selectArray.forEach((select) => {
    if (select.selectedIndex === 0) {
      let name = select.name.replace(/reg_/g, '').replace(/_/g, ' ');
      if (name === 'custom 2') {
        name = 'Which segment(s) do you primarily sell?';
      }
      if (name === 'destination 1') {
        name = 'What Destination/Region Do You Primarily Sell?';
      }
      if (name === 'travel type 1') {
        name = 'What is the #1 type of travel you sell?';
      }
      if (name === 'travel type 2') {
        name = 'What is the #2 type of travel you sell?';
      }
      if (name === 'travel type 3') {
        name = 'What is the #3 type of travel you sell?';
      }
      emptyFields.push(name);
    }
  });

  return emptyFields;
};

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = [];

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  Array.from(selects).forEach((select) => {
    selectArray.push(select);
    // console.log('select', select, select.selectedIndex);
  });

  return (
    inputArray.every((val) => val.checkValidity() === true) &&
    selectArray.every((val) => val.selectedIndex !== 0)
  );
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export const userInputBlank = {
  email: '',
  reg_email: '',
  reg_password: '',
  reg_passwordConfirm: '',
  reg_custom_1: '',
  reg_custom_2: '',
  reg_first_name: '',
  reg_last_name: '',
  reg_title: '',
  reg_agency_name: '',
  reg_host_agency_name: '',
  reg_city: '',
  reg_state: '',
  reg_country: '',

  reg_segment_leisure: false,
  reg_segment_corporate: false,
  reg_segment_group: false,
  reg_agency_affiliation: '',

  reg_travel_type_1: '',
  reg_travel_type_2: '',
  reg_travel_type_3: '',
  reg_destination_1: '',

  reg_marketing_opt_in: false,
};

export default class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userInput: userInputBlank,
      animation: {
        loadingAnim: false,
        loadingAnimRegister: false,
      },
      message: '',
      display: 'login',
      redirect: '',
      appId: 0,
      admission_message: '',
      verified_message: '',
      resend_link: '',
    };

    document.body.classList.add('no-scroll');

    StorageHandler.exists(storageKeys.user).then(res => {
      if (this.props.path !== '/logout' && res) {
        this.setState({ redirect: '/main' });
      } else {
        StorageHandler.removeKeys(userKeys);
      }
    });

    this.login = this.login.bind(this);
    this.loginHandler = this.loginHandler.bind(this);
    this.registerHandler = this.registerHandler.bind(this);
    this.registerHandlerSSO = this.registerHandlerSSO.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.backHandler = this.backHandler.bind(this);
    this.setAnim = this.setAnim.bind(this);
    this.signUpRoute = this.signUpRoute.bind(this);
    this.forgotPasswordRoute = this.forgotPasswordRoute.bind(this);
    this.forgotHandler = this.forgotHandler.bind(this);
  }

  componentWillMount() {
    DataHandler.matchAppId().then(id => {
      this.setState({ appId: id });
    });

    if (this.props.path === '/register') {
      this.setState({ display: 'registerPassword' });
    }
    if (this.props.path === '/register-mobile') {
      this.setState({ display: 'registerPassword' });
    }
  }

  setAnim(type, value) {
    const { animation } = this.state;
    animation[type] = value;
    this.setState({ animation });
  }

  setMessage(message) {
    this.setState({ message });
    document.querySelector('.form__message').style.color = 'red';
    document.querySelector('.form__message').style.opacity = 1;
    document.querySelector('.form__message').style.color = 'black';
  }

  backHandler() {
    this.setState({
      display: 'login',
      message: '',
    });
    document.querySelector('.form__message').style.opacity = 0;
    this.setAnim('loadingAnim', false);
  }

  signUpRoute() {
    this.setState({ display: 'registerPassword' });
  }

  forgotPasswordRoute() {
    this.setState({ display: 'forgot' });
  }

  login(userInfo, saveInfo, customRedir) {
    if (saveInfo) {
      StorageHandler.save(storageKeys.user, userInfo, 2592000000);
    }
    document.body.classList.remove('no-scroll');
    if (customRedir) {
      this.setState({ redirect: customRedir });
    } else {
      this.setState({ redirect: '/main' });
    }
  }

  async loginHandler(
    event,
    email = this.state.userInput.email,
    password = this.state.userInput.password,
  ) {
    event.preventDefault();
    const submit = event.target;
    submit.disabled = true;

    if (!email || !password) {
      toast.error('Please fill in all the required fields', {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      this.setAnim('loadingAnimRegister', false);
      submit.disabled = false;
      return false;
    }

    const exists = await StorageHandler.exists(storageKeys.user);
    if (!exists) {
      const response = await APIHandler.loginUser(email, password);

      if (response.error || response.success === false) {
        submit.disabled = false;
        toast.error(response.message, {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }

      StorageHandler.save(storageKeys.accessToken, response.access_token);
      StorageHandler.save(
        storageKeys.refreshToken,
        response.refresh_token,
        response.expires_in,
      );
      this.setAnim('loadingAnim', true);
      submit.disabled = true;

      const appId = await DataHandler.matchAppId();
      const user = await APIHandler.getUser(appId, response.access_token);
      if (Object.keys(user).length > 0) {
        this.login(user, true);
        return;
      }
    }
    // TODO test
    StorageHandler.load(storageKeys.user).then(userInfo => {
      // Loads userInfo from localStorage
      submit.disabled = false;
      this.login(userInfo, false);
    });
  }

  changeHandler(event) {
    const input = this.state.userInput;
    input[event.target.name] = event.target.value || event.target.checked;
    this.setState({ userInput: input });
  }

  registerHandler() {
    if (checkInputValidity()) {
      this.setAnim('loadingAnimRegister', true);
      const info = this.state.userInput;

      let lang = localStorage.getItem('lang');
      lang = JSON.parse(lang);
      lang = lang.rawData;

      let marketing = false;
      if (info.opt_in_marketing) {
        marketing = true;
      }

      let custom2 = '';
      if (info.reg_segment_leisure) {
        custom2 += 'Leisure ';
      }
      if (info.reg_segment_corporate) {
        custom2 += 'Corporate ';
      }
      if (info.reg_segment_group) {
        custom2 += 'Group ';
      }

      const registerObject = {
        custom_1: info.reg_custom_1,
        custom_2: custom2,
        first_name: info.reg_first_name,
        last_name: info.reg_last_name,
        title: info.reg_title,
        agency_name: info.reg_agency_name,
        host_agency_name: info.reg_host_agency_name,
        city: info.reg_city,
        state: info.reg_state,
        country: info.reg_country,

        agency_affiliation: info.reg_agency_affiliation,

        travel_type_1: info.reg_travel_type_1,
        travel_type_2: info.reg_travel_type_2,
        travel_type_3: info.reg_travel_type_3,
        destination_1: info.reg_destination_1,

        marketing_opt_in: marketing,
      };

      DataHandler.matchAppId().then(appId => {
        APIHandler.setUser(
          info.reg_email,
          this.state.appId,
          registerObject,
        ).then(() => {
          APIHandler.getUserOld(appId, info.reg_email).then(newUser => newUser);
        });
      });
    } else {
      const invalidFields = 'Please fill in all the required fields: ' + checkInputValidityFields().join(', ');
      toast.error(invalidFields, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      this.setAnim('loadingAnimRegister', false);
    }
  }

  async registerHandlerSSO(event) {
    event.preventDefault();
    const submit = event.target;
    submit.disabled = true;
    this.setAnim('loadingAnimRegister', true);

    const name = `${this.state.userInput.reg_first_name} ${this.state.userInput.reg_last_name}`;
    const email = this.state.userInput.reg_email;
    const company = this.state.userInput.reg_agency_name;
    const password = this.state.userInput.reg_password;
    const passwordConfirm = this.state.userInput.reg_passwordConfirm;
    const state = this.state.userInput.reg_state;

    if (!name || !email || !company || !password || !state) {
      const invalidFields = 'Please fill in all the required fields: ' + checkInputValidityFields().join(', ');
      toast.error(invalidFields, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      this.setAnim('loadingAnimRegister', false);
      submit.disabled = false;
      return false;
    }

    if (!checkInputValidity()) {
      const invalidFields = 'Please fill in all the required fields: ' + checkInputValidityFields().join(', ');
      toast.error(invalidFields, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      this.setAnim('loadingAnimRegister', false);
      submit.disabled = false;
      return false;
    }

    if (password !== passwordConfirm) {
      toast.error('The passwords you entered do not match', {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    if (password.length < 8) {
      toast.error('Password needs to be at least 8 characters.', {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    APIHandler.registerSSOUser(
      name,
      email,
      company,
      password,
      passwordConfirm,
    ).then(SSOUser => {
      if (SSOUser.success === false) {
        toast.error(
          'This email address already exists or is invalid. Please try with another email address or login to your account.',
          {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
        submit.disabled = false;
        this.setAnim('loadingAnimRegister', false);
      } else {
        // Old school register
        this.registerHandler();
        const { pathname } = window.location;
        if (pathname === '/register') {
          // TODO: Mobile close script
          toast.success('Registration successful, please check your email to confirm your account. You can now close this window.', {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          submit.disabled = false;
          this.setAnim('loadingAnimRegister', false);

          window.setTimeout(() => {
            window.postMessage('back');
            window.postMessage(
              'back',
              '*',
            );
            window.ReactNativeWebView.postMessage('back');
            window.ReactNativeWebView.postMessage(
              'back',
              '*',
            );
          }, 10000);
        } else {
          toast.success(SSOUser.message, {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          submit.disabled = false;
          this.setAnim('loadingAnimRegister', false);
          window.setTimeout(() => {
            window.location.href = '/login';
          }, 10000);
        }
      }
    });
  }

  forgotHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    const { email } = this.state.userInput;
    this.setAnim('loadingAnimForgot', true);
    APIHandler.forgotPassword(email).then(res => {
      if (res.status !== 200) {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.error("The email address you entered doesn't exist.", {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.success(
          res.message.concat(
            '\n You will be redirect to the login page in 10 seconds',
          ),
          {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
        window.setTimeout(() => {
          window.location.href = '/login';
        }, 10000);
      }
    });
  }

  resendHandler() {
    APIHandler.resendVerificationLink(this.state.resend_link).then(res => {
      if (res.success) {
        toast.success(res.message, {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        this.setState({ resend_link: '' });
      }
    });
  }

  render() {
    const { animation, display, message, redirect, userInput } = this.state;

    return (
      <form className='login__form'>
        {display === 'login' && (
          <Email
            submit={this.loginHandler}
            defaultVal={userInput.email}
            change={this.changeHandler}
            loadingAnim={animation.loadingAnim}
            signUpRoute={this.signUpRoute}
            forgotPasswordRoute={this.forgotPasswordRoute}
          />
        )}
        {display === 'forgot' && (
          <Forgot
            back={this.backHandler}
            defaultVal={userInput.email}
            submit={this.forgotHandler}
            change={this.changeHandler}
            loadingAnimRegister={animation.loadingAnimForgot}
          />
        )}

        {display === 'registerPassword' && (
          <Register
            passwordField
            back={this.backHandler}
            submit={this.registerHandlerSSO}
            change={this.changeHandler}
            loadingAnimRegister={animation.loadingAnimRegister}
          />
        )}

        <h3 className='form__message'>{message}</h3>

        {redirect.length > 0 && <Redirect push to={redirect} />}
        <p className='legal'>
          {i18n.translate('loginScreen.tAndC.agree')}
          <span
            role='button'
            tabIndex={-1}
            data-fancybox='privacy'
            data-type='iframe'
            href='https://travpromobile.com/privacy_policy.html'
          >
            {i18n.translate('loginScreen.tAndC.privacyPolicy')}
          </span>
          {i18n.translate('loginScreen.tAndC.and')}
          <span
            role='button'
            tabIndex={0}
            data-fancybox='terms'
            data-type='iframe'
            href='https://travpromobile.com/terms_of_use.html'
          >
            {i18n.translate('loginScreen.tAndC.termsConditions')}
          </span>
          .
        </p>
        <SweetAlert
          html
          onConfirm={() => {
            this.setState({ admission_message: '' });
          }}
          show={!!this.state.admission_message}
          confirmButtonText='Ok'
          text={this.state.admission_message}
        />
        <SweetAlert
          html
          title='Email not Verified:'
          onConfirm={() => {
            this.setState({ verified_message: '' });
          }}
          onCancel={() => {
            this.setState({ verified_message: '' });
            this.resendHandler();
          }}
          show={!!this.state.verified_message}
          confirmButtonText='Ok'
          cancelButtonText='Resend email'
          showCancelButton
          text={this.state.verified_message}
        />
        <ToastContainer draggablePercent={70} />
      </form>
    );
  }
}

LoginForm.propTypes = {
  path: PropTypes.string,
};

LoginForm.defaultProps = {
  path: '/login',
};
